import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, switchMap} from 'rxjs';
import {environment} from 'src/environments/environment';
import {
  IHolidays,
  IOffices,
  IDepartmentDropdowns,
  INewPosition,
} from '../interfaces/settings.iterfaces';
import {IDropdownObject} from '../interfaces/dropdown-object.interface';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private url = environment.API + 'api/';
  private dropdownUrl = this.url + 'v1/DropDown/';

  constructor(private http: HttpClient) {}

  getAllHolidays(): Observable<IHolidays[]> {
    return this.http.get<IHolidays[]>(`${this.url}Holidays/getAll`);
  }

  updateHoliday(data: IHolidays): Observable<IHolidays> {
    return this.http.put<IHolidays>(`${this.url}Holidays/update`, data);
  }

  deleteHoliday(id: number): Observable<IHolidays> {
    return this.http.delete<IHolidays>(`${this.url}Holidays/delete/${id}`);
  }

  addNewHoliday(data: IHolidays): Observable<IHolidays> {
    return this.http.post<IHolidays>(`${this.url}Holidays/add`, data);
  }

  getOffices(): Observable<IOffices[]> {
    return this.http.get<IOffices[]>(`${this.url}Office/all`);
  }

  getCountriesList(): Observable<string[]> {
    return this.http.get<string[]>(`${this.url}Office/countries`);
  }

  addOffice(office: IOffices): Observable<IOffices> {
    return this.http.post<IOffices>(`${this.url}Office/new`, office);
  }

  getDepartmentDropdowns(): Observable<IDepartmentDropdowns> {
    return this.http.get<IDepartmentDropdowns>(`${this.dropdownUrl}`);
  }

  getTechStacks(): Observable<IDropdownObject[]> {
    return this.http.get<IDropdownObject[]>(
      `${this.dropdownUrl}stackTechnology`
    );
  }

  addTechStack(name: string): Observable<IDropdownObject[]> {
    return this.http
      .post<void>(`${this.dropdownUrl}stackTechnology`, {name})
      .pipe(switchMap(() => this.getTechStacks()));
  }

  deleteTechStack(id: number | string): Observable<IDropdownObject[]> {
    return this.http
      .delete<void>(`${this.dropdownUrl}stackTechnology/${id}`)
      .pipe(switchMap(() => this.getTechStacks()));
  }

  getPositions(): Observable<IDropdownObject[]> {
    return this.http.get<IDropdownObject[]>(`${this.dropdownUrl}position`);
  }

  addPosition(body: INewPosition): Observable<IDropdownObject[]> {
    return this.http
      .post<void>(`${this.dropdownUrl}position`, body)
      .pipe(switchMap(() => this.getPositions()));
  }

  deletePosition(id: number | string): Observable<IDropdownObject[]> {
    return this.http
      .delete<void>(`${this.dropdownUrl}position/${id}`)
      .pipe(switchMap(() => this.getPositions()));
  }

  getFrameworks(): Observable<IDropdownObject[]> {
    return this.http.get<IDropdownObject[]>(`${this.dropdownUrl}frameworks`);
  }

  addFramework(name: string): Observable<IDropdownObject[]> {
    return this.http
      .post<void>(`${this.dropdownUrl}framework`, {name})
      .pipe(switchMap(() => this.getFrameworks()));
  }

  deleteFramework(id: number | string): Observable<IDropdownObject[]> {
    return this.http
      .delete<void>(`${this.dropdownUrl}framework/${id}`)
      .pipe(switchMap(() => this.getFrameworks()));
  }
}
